import { createSelector } from 'reselect';
import get from 'lodash/fp/get';

import { TERM_ARCHIVE } from 'config/types/path';
import tagToLearnLanguage from 'utils/tagToLearnLanguage';
import getMatch from './getMatch';
import { getEdition } from './getEdition';

const getLearnLanguage = createSelector(
  [getMatch, getEdition],
  (match, edition) => {
    const { pathType, params: { slug } } = match;

    if (pathType !== TERM_ARCHIVE) {
      return get('query.learn_language', match);
    }

    return tagToLearnLanguage(edition, slug);
  },
);

export default getLearnLanguage;
